import styled from 'styled-components';

export const ActionBar = styled.div`
  position: absolute;
  background: #e9f3fd;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;

export const CellContentWrapper = styled.div`
  position: relative;
  width: 100%;
`;
